import { mapActions } from 'vuex'
export default {
  data () {
    return {
      fichero: null,
      enviado: false,
      enviadoObjetos: false,
      loading: false,
      valid: true,
      objetosOK: false,
      objetosKO: false,
      listaObjetosOK: [],
      listaObjetosKO: [],
      seccion: ''
    }
  },
  computed: {
    headersObjetoKO () {
      switch(this.seccion) {
        case 'sociedades':
          return [
            { text: 'CÓDIGO', sortable: true, value: 'CÓDIGO', align: 'center' },
            { text: 'DESCRIPCIÓN', value: 'DESCRIPCIÓN', sortable: true, align: 'center' },
            { text: 'NIF', value: 'NIF', sortable: true, align: 'center' },
            { text: 'MOTIVO', value: 'MOTIVO', sortable: true, align: 'center' }
          ]
        case 'inmuebles':
          return [
            { text: 'PROMOCIÓN', sortable: true, value: 'PROMOCIÓN', align: 'center' },
            { text: 'TIPO INMUEBLE', value: 'TIPO_INMUEBLE', sortable: true, align: 'center' },
            { text: 'BLOQUE', value: 'BLOQUE', sortable: true, align: 'center' },
            { text: 'PORTAL', value: 'PORTAL', sortable: true, align: 'center' },
            { text: 'ESCALERA', value: 'ESCALERA', sortable: true, align: 'center' },
            { text: 'PLANTA', value: 'PLANTA', sortable: true, align: 'center' },
            { text: 'PUERTA', value: 'PUERTA', sortable: true, align: 'center' },
            { text: 'ALIAS', value: 'ALIAS', sortable: true, align: 'center' },
            { text: 'CÓDIGO', value: 'CÓDIGO', sortable: true, align: 'center' },
            { text: 'DESCRIPCIÓN', value: 'DESCRIPCIÓN', sortable: true, align: 'center' },
            { text: 'DIRECCIÓN', value: 'DIRECCIÓN', sortable: true, align: 'center' },
            { text: 'CÓDIGO POSTAL', value: 'CÓDIGO_POSTAL', sortable: true, align: 'center' },
            { text: 'POBLACIÓN', value: 'POBLACIÓN', sortable: true, align: 'center' },
            { text: 'PROVINCIA', value: 'PROVINCIA', sortable: true, align: 'center' },
            { text: 'PAÍS', value: 'PAÍS', sortable: true, align: 'center' },
            { text: 'MOTIVO', value: 'MOTIVO', sortable: true, align: 'center' }
          ]
        case 'promociones':
          return [
            { text: 'CÓDIGO', sortable: true, value: 'CÓDIGO', align: 'center' },
            { text: 'NOMBRE', value: 'NOMBRE', sortable: true, align: 'center' },
            { text: 'SOCIEDAD', sortable: true, value: 'SOCIEDAD', align: 'center' },
            { text: 'SECTOR', value: 'SECTOR', sortable: true, align: 'center' },
            { text: 'DIRECCIÓN', sortable: true, value: 'DIRECCIÓN', align: 'center' },
            { text: 'CÓDIGO POSTAL', value: 'CÓDIGO_POSTAL', sortable: true, align: 'center' },
            { text: 'POBLACIÓN', sortable: true, value: 'POBLACIÓN', align: 'center' },
            { text: 'PROVINCIA', value: 'PROVINCIA', sortable: true, align: 'center' },
            { text: 'PAÍS', sortable: true, value: 'PAÍS', align: 'center' },
            { text: 'MOTIVO', value: 'MOTIVO', sortable: true, align: 'center' }
          ]
        case 'clientes':
          return [
            { text: 'CÓDIGO', sortable: true, value: 'CÓDIGO', align: 'center' },
            { text: 'NOMBRE Y APELLIDOS', value: 'NOMBRE', sortable: true, align: 'center' },
            { text: 'CÓDIGO DE SOCIEDAD', value: 'SOCIEDAD', sortable: true, align: 'center' },
            { text: 'TELÉFONO', value: 'TELÉFONO', sortable: true, align: 'center' },
            { text: 'MÓVIL', value: 'MÓVIL', sortable: true, align: 'center' },
            { text: 'EMAIL', value: 'EMAIL', sortable: true, align: 'center' },
            { text: 'MOTIVO', value: 'MOTIVO', sortable: true, align: 'center' }
          ]
        case 'operaciones':
          return [
            { text: 'PROMOCIÓN', sortable: true, value: 'PROMOCIÓN', align: 'center' },
            { text: 'CÓDIGO', value: 'CÓDIGO', sortable: true, align: 'center' },
            { text: 'INMUEBLE', value: 'INMUEBLE', sortable: true, align: 'center' },
            { text: 'CLIENTE', value: 'CLIENTE', sortable: true, align: 'center' },
            { text: 'ÁMBITO', value: 'ÁMBITO', sortable: true, align: 'center' },
            { text: 'MOTIVO', value: 'MOTIVO', sortable: true, align: 'center' }
          ]
        case 'proveedores':
          return [
            { text: 'NOMBRE DEL PROVEEDOR', sortable: true, value: 'NOMBRE', align: 'center' },
            { text: 'CODIGO DE SOCIEDAD', value: 'SOCIEDAD', sortable: true, align: 'center' },
            { text: 'TIPO DE DOCUMENTO', value: 'TIPO_DOCUMENTO', sortable: true, align: 'center' },
            { text: 'NÚMERO DEL DOCUMENTO', value: 'NÚMERO_DOCUMENTO', sortable: true, align: 'center' },
            { text: 'MÓVIL', value: 'MÓVIL', sortable: true, align: 'center' },
            { text: 'TELÉFONO', value: 'TELÉFONO', sortable: true, align: 'center' },
            { text: 'EMAIL', value: 'EMAIL', sortable: true, align: 'center' },


            { text: 'MOTIVO', value: 'MOTIVO', sortable: true, align: 'center' }
          ]
          case 'tiposInmueble':
            return [
              { text: 'CÓDIGO', sortable: true, value: 'CÓDIGO', align: 'center' },
              { text: 'DESCRIPCIÓN', value: 'DESCRIPCIÓN', sortable: true, align: 'center' },
              { text: 'MOTIVO', value: 'MOTIVO', sortable: true, align: 'center' }
            ]
        default:
          return
      }
    },
    headersObjetoOK () {
      switch(this.seccion) {
        case 'sociedades':
          return [
            { text: 'CÓDIGO', sortable: true, value: 'CÓDIGO', align: 'center' },
            { text: 'DESCRIPCIÓN', value: 'DESCRIPCIÓN', sortable: true, align: 'center' },
            { text: 'NIF', value: 'NIF', sortable: true, align: 'center' },
          ]
        case 'inmuebles':
          return [
            { text: 'PROMOCIÓN', sortable: true, value: 'PROMOCIÓN', align: 'center' },
            { text: 'TIPO INMUEBLE', value: 'TIPO_INMUEBLE', sortable: true, align: 'center' },
            { text: 'BLOQUE', value: 'BLOQUE', sortable: true, align: 'center' },
            { text: 'PORTAL', value: 'PORTAL', sortable: true, align: 'center' },
            { text: 'ESCALERA', value: 'ESCALERA', sortable: true, align: 'center' },
            { text: 'PLANTA', value: 'PLANTA', sortable: true, align: 'center' },
            { text: 'PUERTA', value: 'PUERTA', sortable: true, align: 'center' },
            { text: 'ALIAS', value: 'ALIAS', sortable: true, align: 'center' },
            { text: 'CÓDIGO', value: 'CÓDIGO', sortable: true, align: 'center' },
            { text: 'DESCRIPCIÓN', value: 'DESCRIPCIÓN', sortable: true, align: 'center' },
            { text: 'DIRECCIÓN', value: 'DIRECCIÓN', sortable: true, align: 'center' },
            { text: 'CÓDIGO POSTAL', value: 'CÓDIGO_POSTAL', sortable: true, align: 'center' },
            { text: 'POBLACIÓN', value: 'POBLACIÓN', sortable: true, align: 'center' },
            { text: 'PROVINCIA', value: 'PROVINCIA', sortable: true, align: 'center' },
            { text: 'PAÍS', value: 'PAÍS', sortable: true, align: 'center' },
          ]
        case 'promociones':
          return [
            { text: 'CÓDIGO', sortable: true, value: 'CÓDIGO', align: 'center' },
            { text: 'NOMBRE', value: 'NOMBRE', sortable: true, align: 'center' },
            { text: 'SOCIEDAD', sortable: true, value: 'SOCIEDAD', align: 'center' },
            { text: 'SECTOR', value: 'SECTOR', sortable: true, align: 'center' },
            { text: 'DIRECCIÓN', sortable: true, value: 'DIRECCIÓN', align: 'center' },
            { text: 'CÓDIGO POSTAL', value: 'CÓDIGO_POSTAL', sortable: true, align: 'center' },
            { text: 'POBLACIÓN', sortable: true, value: 'POBLACIÓN', align: 'center' },
            { text: 'PROVINCIA', value: 'PROVINCIA', sortable: true, align: 'center' },
            { text: 'PAÍS', sortable: true, value: 'PAÍS', align: 'center' },
          ]
        case 'clientes':
          return [
            { text: 'CÓDIGO', sortable: true, value: 'CÓDIGO', align: 'center' },
            { text: 'NOMBRE Y APELLIDOS', value: 'NOMBRE', sortable: true, align: 'center' },
            { text: 'CÓDIGO DE SOCIEDAD', value: 'SOCIEDAD', sortable: true, align: 'center' },
            { text: 'TELÉFONO', value: 'TELÉFONO', sortable: true, align: 'center' },
            { text: 'MÓVIL', value: 'MÓVIL', sortable: true, align: 'center' },
            { text: 'EMAIL', value: 'EMAIL', sortable: true, align: 'center' },
          ]
        case 'operaciones':
          return [
            { text: 'PROMOCIÓN', sortable: true, value: 'PROMOCIÓN', align: 'center' },
            { text: 'CÓDIGO', value: 'CÓDIGO', sortable: true, align: 'center' },
            { text: 'INMUEBLE', value: 'INMUEBLE', sortable: true, align: 'center' },
            { text: 'CLIENTE', value: 'CLIENTE', sortable: true, align: 'center' },
            { text: 'ÁMBITO', value: 'ÁMBITO', sortable: true, align: 'center' },
          ]
        case 'proveedores':
          return [
            { text: 'NOMBRE DEL PROVEEDOR', sortable: true, value: 'NOMBRE', align: 'center' },
            { text: 'CODIGO DE SOCIEDAD', value: 'SOCIEDAD', sortable: true, align: 'center' },
            { text: 'TIPO DE DOCUMENTO', value: 'TIPO_DOCUMENTO', sortable: true, align: 'center' },
            { text: 'NÚMERO DEL DOCUMENTO', value: 'NÚMERO_DOCUMENTO', sortable: true, align: 'center' },
            { text: 'MÓVIL', value: 'MÓVIL', sortable: true, align: 'center' },
            { text: 'TELÉFONO', value: 'TELÉFONO', sortable: true, align: 'center' },
            { text: 'EMAIL', value: 'EMAIL', sortable: true, align: 'center' },
          ]
          case 'tiposInmueble':
            return [
              { text: 'CÓDIGO', sortable: true, value: 'CÓDIGO', align: 'center' },
              { text: 'DESCRIPCIÓN', value: 'DESCRIPCIÓN', sortable: true, align: 'center' },
            ]
        default:
          return
      }
    },
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      realizarImportacionSociedades: 'gestion/realizarImportacionSociedades',
      realizarImportacionTiposInmueble: 'gestion/realizarImportacionTiposInmueble',
      realizarImportacionClientes: 'gestion/realizarImportacionClientes',
      realizarImportacionProveedores: 'gestion/realizarImportacionProveedores',
      realizarImportacionPromociones: 'gestion/realizarImportacionPromociones',
      realizarImportacionInmuebles: 'gestion/realizarImportacionInmuebles',
      realizarImportacionOperaciones: 'gestion/realizarImportacionOperaciones',
    }),
    descargarInformeOK () {
      var csvString = atob(this.informeOK.file_base64)
      var universalBOM = "\uFEFF";
      var a = window.document.createElement('a');
      a.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM+csvString));
      a.setAttribute('download', this.informeOK.name);
      window.document.body.appendChild(a);
      a.click()
      window.document.body.removeChild(a)
    },
    descargarInformeKO () {
      var csvString = atob(this.informeKO.file_base64)
      var universalBOM = "\uFEFF";
      var a = window.document.createElement('a');
      a.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM+csvString));
      a.setAttribute('download', this.informeKO.name);
      window.document.body.appendChild(a);
      a.click()
      window.document.body.removeChild(a)
    },
    descargaPlantilla () {
      switch(this.seccion) {
        case 'sociedades':
          location.href = './plantillas/Plantilla-importacion-sociedades-Posventa.xls'
          break
        case 'tiposInmueble':
          location.href = './plantillas/Plantilla-importacion-tiposInmueble-Posventa.xls'
          break
        case 'inmuebles':
          location.href = './plantillas/Plantilla-importacion-inmuebles-Posventa.xls'
          break
        case 'promociones':
          location.href = './plantillas/Plantilla-importacion-promociones-Posventa.xls'
          break
        case 'clientes':
          location.href = './plantillas/Plantilla-importacion-clientes-Posventa.xls'
          break
        case 'operaciones':
          location.href = './plantillas/Plantilla-importacion-operaciones-Posventa.xls'
          break
        case 'proveedores':
          location.href = './plantillas/Plantilla-importacion-proveedores-Posventa.xls'
          break
        default:
          return
      }
    },
    descargaFormato () {
      switch(this.seccion) {
        case 'sociedades':
          location.href = './plantillas/Formato-importacion-sociedades-Posventa.xlsx'
          break
        case 'promociones':
          location.href = './plantillas/Formato-importacion-promociones-Posventa.xlsx'
          break
        case 'inmuebles':
          location.href = './plantillas/Formato-importacion-inmuebles-Posventa.xlsx'
          break
        case 'tiposInmueble':
          location.href = './plantillas/Formato-importacion-tiposInmueble-Posventa.xlsx'
          break
        case 'clientes':
          location.href = './plantillas/Formato-importacion-clientes-Posventa.xlsx'
          break
        case 'operaciones':
          location.href = './plantillas/Formato-importacion-operaciones-Posventa.xlsx'
          break
        case 'proveedores':
          location.href = './plantillas/Formato-importacion-proveedores-Posventa.xlsx'
          break
        default:
          return
      }
    },
    vaciar () {
      this.fichero = null
      this.enviado = false
      this.enviadoObjetos = false
      this.objetosOK = false
      this.objetosKO = false
      this.listaObjetosOK = []
      this.listaObjetosKO = []
      this.$emit('input')
    },
    enviar () {
      this.$refs.form.validate()
      if (!this.valid) {
        this.addAlert({ texto: 'Por favor, seleccione un formato de archivo correcto.', color: 'error' })
      } else {
        if (this.fichero !== null) {
          try {
            this.loading = true
            const file = this.fichero
            const nombreFichero = file.name
            const tipoFichero = file.type
            var reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = async () => {
              this.imageBase64 = reader.result
              const arrImageSplit = this.imageBase64.split(',')
              const values = {
                name: nombreFichero,
                type: tipoFichero,
                file_base64: arrImageSplit[1]
              }      
              this.enviarFichero(values)
            }
          } catch (error) {
            this.addAlert({ texto: 'Se ha producido un error.', color: 'error' })
          }
        }
      }
    },
    async enviarFichero(values) {
      // eslint-disable-next-line no-unreachable
      var loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false
      })
      switch(this.seccion) {
        case 'sociedades':
          await this.realizarImportacionSociedades(values)
          .then((response) => {
            this.obtenerResultados(response) 
          })
          .catch((response) => {
            this.addAlert({ texto: response.message, color: 'error' })
          })
          break;
        case 'promociones':
          await this.realizarImportacionPromociones(values)
            .then((response) => {
              this.obtenerResultados(response) 
            })
            .catch((response) => {
              this.addAlert({ texto: response.message, color: 'error' })
            })
          break;
        case 'tiposInmueble':
          await this.realizarImportacionTiposInmueble(values)
            .then((response) => {
              this.obtenerResultados(response) 
            })
            .catch((response) => {
              this.addAlert({ texto: response.message, color: 'error' })
            })
          break;
        case 'inmuebles':
          await this.realizarImportacionInmuebles(values)
            .then((response) => {
              this.obtenerResultados(response) 
            })
            .catch((response) => {
              this.addAlert({ texto: response.message, color: 'error' })
            })
          break;
        case 'clientes':
          await this.realizarImportacionClientes(values)
            .then((response) => {
              this.obtenerResultados(response) 
            })
            .catch((response) => {
              this.addAlert({ texto: response.message, color: 'error' })
            })
          break;
        case 'operaciones':
          await this.realizarImportacionOperaciones(values)
            .then((response) => {
              this.obtenerResultados(response) 
            })
            .catch((response) => {
              this.addAlert({ texto: response.message, color: 'error' })
            })
          break;
        case 'proveedores':
          await this.realizarImportacionProveedores(values)
            .then((response) => {
              this.obtenerResultados(response) 
            })
            .catch((response) => {
              this.addAlert({ texto: response.message, color: 'error' })
            })
          break;
      }
      loader.hide()
      this.loading = false
    },
    obtenerResultados(response){
      this.enviadoObjetos = true
      let totalOK = 0
      let totalKO = 0
      if (response.ok && response.ok.length > 0) {
        this.objetosOK = true
        this.listaObjetosOK = response.ok
        totalOK = response.ok.length
      }
      if (response.ko && response.ko.length > 0) {
        this.objetosKO = true
        this.listaObjetosKO = response.ko
        totalKO = response.ko.length
      }
      let texto = this.$t('importacion_exitosa') + ' ' + totalOK + ' Importados con éxito, ' + totalKO + ' No importados'
      this.addAlert({ texto: texto, color: 'success' })
    } 
  }
  
}
